<template>
  <div style="height: 100%">
    <material-card
      color="#68c6b3"
      title="Activity stats that are benefitting your Good Cause"
      offset="0"
      style="height: 100%"
    >
      <v-layout justify-center wrap v-if="stats != undefined">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex class="mt-0" xs12 sm6 style="text-align: center">
              <v-layout class="pa-2" justify-center wrap>
                <v-flex xs12>
                  <p
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 25pt !important;
                    "
                    class="mb-0"
                  >
                    {{ formatMoney(stats.revenue) }}
                  </p>
                  <p style="color: #325181; font-size: 15pt !important">
                    Revenue Generated <br />
                    For Upstream Suppliers (excl gst)
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="mt-0" xs12 sm6 style="text-align: center">
              <v-layout class="pa-2" justify-center wrap>
                <v-flex xs12>
                  <p
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 25pt !important;
                    "
                    class="mb-0"
                  >
                    {{ formatMoney(stats.cC / 2) }}
                  </p>
                  <p style="color: #325181; font-size: 15pt !important">
                    Your UpstreamNZ direct <br />
                    contribution total <br />
                    through sales (excl gst)
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    v-on="on"
                    class="mb-0"
                  >
                    {{ stats.attemptedLeadsCount }}
                  </p>
                  <p v-on="on" style="color: #325181">
                    Attempted Opportunities
                  </p>
                </template>
                <span
                  >These are brokered opportunities we have presented to an
                  Impact Buyer but they indicated wasn't a fit for various
                  reasons</span
                >
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    class="mb-0"
                    v-on="on"
                  >
                    {{ stats.leadsCount }}
                  </p>
                  <p v-on="on" style="color: #325181">Active Opportunities</p>
                </template>
                <span>
                  These are opportunities that are connected to Impact Buyers we
                  are prospecting. You'll benefit from these enquiries if the
                  customer is keen to engage
                </span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <p
                style="
                  color: #325181;
                  font-weight: bold;
                  font-size: 20pt !important;
                "
                class="mb-0"
              >
                {{
                  parseInt(this.stats.enquiryEnquiries) +
                  parseInt(this.stats.commsConfirmedEnquiries) +
                  parseInt(this.stats.salePendingEnquiries) +
                  parseInt(this.stats.saleConfirmedEnquiries)
                }}
              </p>
              <p style="color: #325181">Active Enquiries</p>
            </v-flex>
          </v-layout>
          <!--  -->
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    v-on="on"
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    class="mb-0"
                  >
                    {{ stats.saleCompletedEnquiries }}
                  </p>
                  <p v-on="on" style="color: #325181">Sales Completed</p>
                </template>
                <span
                  >These are sales have been completed. This stat also includes
                  repeat invoices from sales that have an ongoing nature</span
                >
              </v-tooltip>
            </v-flex>
          </v-layout>
          <!--  -->
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    v-on="on"
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    class="mb-0"
                  >
                    {{ stats.saleFallenThroughEnquiries }}
                  </p>
                  <p v-on="on" style="color: #325181">Sales Fallen Through</p>
                </template>
                <span
                  >These are enquires that have fallen through for various
                  reasons</span
                >
              </v-tooltip>
            </v-flex>
          </v-layout>
          <!--  -->
        </v-flex>
        <!-- TODO: AVG Contribution per sale
        
        "this is the avg amount of contribution value you recieve per completed sale. Based on historic numbers"
         -->
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    v-on="on"
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    class="mb-0"
                  >
                    {{
                      calculatePercent(
                        stats.completedEnquiriesCount -
                          stats.saleFallenThroughEnquiries,
                        stats.completedEnquiriesCount
                      )
                    }}%
                  </p>
                  <p v-on="on" style="color: #325181">Conversion Rate</p>
                </template>
                <span
                  >The rate that the enquiries are converted to a completed sale
                  where you are chosen as the Good Cause.</span
                >
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="$vuetify.breakpoint.smAndUp" xs6 class="pb-4 mb-4">
          <apexChart
            height="300px"
            :options="upstreamStatusChartOptions"
            :series="upstreamStatusSeries"
          />
        </v-flex>
        <v-flex
          :xs6="$vuetify.breakpoint.smAndUp"
          :xs12="!$vuetify.breakpoint.smAndUp"
          class="pb-4 mb-4"
        >
          <p style="font-weight: bold">
            Click here to request Upstream to add new Impact Buyer connected to
            your Good Cause
          </p>
          <v-btn
            block
            color="#325181"
            dark
            @click="newImpactBuyerFormDialog = true"
            >Request UNZ To add new Impact Buyer</v-btn
          >
        </v-flex>

        <v-divider></v-divider>
        <v-flex
          v-if="$vuetify.breakpoint.smAndUp && stats != undefined"
          xs12
          class="py-1"
        >
          <v-progress-linear
            background-color="#325181"
            color="#4cc7e8"
            height="40"
            class="ma-1"
            :value="
              calculatePercent(stats.consumerEnquiries, stats.enquiriesCount)
            "
          ></v-progress-linear>
          <p>
            <span>
              <div
                class="ml-1"
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #4cc7e8;
                  display: inline-block;
                "
              ></div>
              Consumer Enquiries: {{ stats.consumerEnquiries }} ({{
                calculatePercent(stats.consumerEnquiries, stats.enquiriesCount)
              }}%)
            </span>

            <span style="float: right">
              <div
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #325181;
                  display: inline-block;
                "
              ></div>
              Business or Org. Enquiries: {{ stats.businessEnquiries }} ({{
                calculatePercent(stats.businessEnquiries, stats.enquiriesCount)
              }}%)
            </span>
          </p>
        </v-flex>
        <v-flex xs12 class="py-1">
          <v-progress-linear
            background-color="#68c6b3"
            color="#58595b"
            height="40"
            class="ma-1"
            :value="
              calculatePercent(
                stats.saleFallenThroughEnquiries,
                stats.completedEnquiriesCount
              )
            "
          ></v-progress-linear>
          <p>
            <span>
              <div
                class="ml-1"
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #58595b;
                  display: inline-block;
                "
              ></div>
              Unconverted:
              {{ stats.saleFallenThroughEnquiries }}
              ({{
                calculatePercent(
                  stats.saleFallenThroughEnquiries,
                  stats.completedEnquiriesCount
                )
              }}%)
            </span>

            <span style="float: right">
              <div
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #68c6b3;
                  display: inline-block;
                "
              ></div>
              Converted: {{ stats.completedEnquiriesCount }} ({{
                calculatePercent(
                  stats.completedEnquiriesCount -
                    stats.saleFallenThroughEnquiries,
                  stats.completedEnquiriesCount
                )
              }}%)
            </span>
          </p>
        </v-flex>
      </v-layout>
    </material-card>
    <v-dialog max-width="600px" v-model="newImpactBuyerFormDialog">
      <v-card v-if="newImpactBuyerFormDialog">
        <v-toolbar color="#325181" dense dark class="mb-0">
          New Impact Buyer Request
          <v-spacer></v-spacer>

          <v-btn icon @click="newImpactBuyerFormDialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="impactBusinessForm">
            <v-layout wrap row>
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  label="Impact Buyer Name"
                  v-model="ibForm.name"
                  :rules="[(v) => !!v || 'Impact Buyer Name is required']"
                />
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  v-model="ibForm.impactLeadConnectionName"
                  label="Name of Contact"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-1">
                <v-text-field
                  v-model="ibForm.impactGoodcauseConnectionRelation"
                  label="The Connection to your Good Cause"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  v-model="ibForm.impactLeadConnectionTitle"
                  label="Their Title where they work ( if known )"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  v-model="ibForm.impactPhone"
                  label="Phone of Contact"
                />
              </v-flex>
              <v-flex xs12 class="pa-1">
                <v-text-field
                  v-model="ibForm.impactEmail"
                  :rules="[(v) => !!v || 'Email is required']"
                  label="Email of Contact"
                  required
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn
            color="success"
            :loading="submitLoading"
            @click="requestIBCreation"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import apexChart from "@/components/wrappers/apexChart.vue";

  export default {
    props: ["stats"],
    components: { apexChart },
    data: () => ({
      upstreamStatusSeries: [],
      upstreamStatusChartOptions: {
        chart: {
          type: "donut",
        },
        fill: {},
        colors: ["#325181", "#4cc7e8", "#68c6b3", "#58595b"],
        labels: [
          "Active Opportunities",
          "Active Enquiries",
          "Sales Completed",
          "Sales Fallen Through",
        ],
      },
      graphRenderReady: false,
      chartWidth: 300,
      chartWidthDebounce: null,

      newImpactBuyerFormDialog: false,
      ibForm: {},
      submitLoading: false,
    }),
    computed: {
      ...mapGetters({}),
    },
    watch: {
      stats: function () {
        this.updateGraphs();
      },
    },
    mounted() {
      this.updateGraphs();
    },

    methods: {
      updateGraphs() {
        if (this.stats != undefined) {
          this.upstreamStatusSeries = [
            parseInt(this.stats.leadsCount),
            parseInt(this.stats.enquiryEnquiries) +
              parseInt(this.stats.commsConfirmedEnquiries) +
              parseInt(this.stats.salePendingEnquiries) +
              parseInt(this.stats.saleConfirmedEnquiries),
            parseInt(this.stats.saleCompletedEnquiries),
            parseInt(this.stats.saleFallenThroughEnquiries),
          ];
        }
      },
      calculatePercent(amount, total) {
        if (amount == 0) {
          return 0;
        }
        return parseFloat((parseInt(amount) / parseInt(total)) * 100).toFixed(1);
      },
      formatMoney(amount) {
        let formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
        return formatter.format(amount);
      },
      requestIBCreation() {
        if (this.$refs.impactBusinessForm.validate()) {
          this.ibForm.goodCause_id = this.stats.goodCause_id;
          this.submitLoading = true;
          this.$store
            .dispatch("goodCauses/requestIBCreation", this.ibForm)
            .then((res) => {
              this.submitLoading = false;
              this.newImpactBuyerFormDialog = false;
            });
        }
      },
    },
    filters: {
      moment: function (date) {
        return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
      },
    },
  };
</script>

<style lang="css">
  #statsModule h4.title.font-weight-light.mb-2 {
    font-weight: bold !important;
  }
</style>
